<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="2">
          OT Bill: Operation
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date"
                  label="Select [Start Date - End Date]"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <template>
            <v-autocomplete
                :items="doctors"
                item-text="dr_name"
                item-key="id"
                item-value="id"
                label="Doctor List"
                v-model="search_doctor_id"
                :loading="loading"
                outlined
                dense
                chips
            ></v-autocomplete>
          </template>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              outlined
              hide-details
              dense
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn
              depressed
              color="primary"
              append-icon="mdi-printer"
              v-on:click="printList"
          >Print</v-btn
          >
        </v-col>
      </v-row>
    </v-card-title>
    <v-card id="print">
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :search="search"
          dense
          :loading="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          mobile-breakpoint="0"
          :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.operation_subhead="{ item }">
          <span v-if="item.operation">{{ item.operation.name }}</span>
          <v-chip v-if="item.operation_subhead" class="ma-2" color="error" outlined small>
            {{ item.operation_subhead }}
          </v-chip>
        </template>
        <template v-slot:item.opp_status="{ item }">
          <v-chip :color="getColor(item.opp_status)" dark>
            {{ item.opp_status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.paid_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.paid_amount) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="ot_details(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="orange"
                  label
                  outlined
                  small
              ><v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Registration Details</span>
          </v-tooltip>
          <v-tooltip top v-if="item.opp_status == 'open'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="create_invoice(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="orange"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-motorbike </v-icon>
                <v-icon left> mdi-chevron-double-right</v-icon>
              </v-chip>
            </template>
            <span>Bill Generate</span>
          </v-tooltip>
          <v-tooltip top v-if="item.opp_status == 'close'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="otbillview(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="success"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-eye </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Bill View</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="recieve_money(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
              >
                <v-icon left> mdi-cash </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Receive Money</span>
          </v-tooltip> -->

          <v-tooltip top v-if="item.paid_amount">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="admissionform(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-message-text </v-icon>
                <v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>Admission form</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10),
      ],
      search_doctor_id: '',
      menu2: false,
      loading: true,
      headers: [
        {text: "OT ID", align: "start", sortable: false, value: "registration_no",},
        {text: "ID", value: "patient_id",},
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Operation Name", sortable: true, value: "operation_subhead" },
        { text: "OT Date", value: "opp_date"},
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Status", value: "opp_status" },

        // { text: "Create at", value: "create_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          icon: "edit",
        },
      ],

      desserts: [],
      doctors: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  watch: {
    date() {
      this.desserts = []
      if (this.date.length == 2) {
        this.getOperations()
      }
    },
    search_doctor_id() {
      this.getOperations()
    }
  },
  created() {
    this.getDoctors();
    this.getOperations()
  },
  methods: {
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getOperations() {
      this.loading = true;
      this.desserts = []
      atshq
          .get("ot-bill?op_type=Operation&date=" + this.date + "&doctor_id=" + this.search_doctor_id)
          .then((response) => {
            this.desserts = response.data.data;
            this.loading = false;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message)
          });
    },
    b_number_format(n) {
      return n != null ? n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    getColor(status) {
      if (status == "open") return "orange";
      else if (status == "close") return "green";
      else if (status == "cancel") return "red";
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
      // console.log(this.desserts.item);
      alert(item.patient_id);
    },
    create_invoice(item) {
      window.location.href = "/otbill-create/" + item.registration_no;
    },
    recieve_money(item) {
      window.location.href = "otbill-received/" + item.registration_no;
      // window.location.href =
      //   this.returnUrl +
      //   "front_desk/invoice/" +
      //   item.registration_no +
      //   "#otbillarea";
    },
    otbillview(item) {
      window.open(this.returnUrl + "printdoc/invoiceDoctorOt/" + item.registration_no);
    },
    admissionform(item) {
      window.open(
          this.returnUrl + "printdoc/opAdmissionFormRegNo/" + item.registration_no + "/0"
      );
    },
    injection(item) {
      window.open(
          this.returnUrl + "printdoc/avs_injectionRegNo/" + item.registration_no + "/0"
      );
    },
    yaglaser(item) {
      window.open(
          this.returnUrl + "printdoc/yagLaserRegNo/" + item.registration_no + "/0"
      );
    },
    laserChart(item) {
      window.open(
          this.returnUrl + "printdoc/laserProformaRegNo/" + item.registration_no + "/0"
      );
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    invoice_gen(item) {
      this.$router.push("/invoice-create/" + item.patient_id);
      // console.warn(item);
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=950, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
          '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
          '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );

      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px; }"
      );
      docprint.document.write("table th, table th {text-align: center;}");
      docprint.document.write("table {width: 100%; border-spacing: 0px;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(
          '<h2 class="box-title" style="margin:0px; padding: 0px;">Dristi Eye Hospital</h2>'
      );
      docprint.document.write(
          "<p style='text-transform: uppercase;'>OT Bill: Operation <br/>" +
          "<br/>Date: " +
          this.date +
          "</p>"
      );
      docprint.document.write(
          '<div style="width: 100%;float: left;border-top: 5px solid silver;padding-bottom: 5px;"></div>'
      );
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>

